export const keys = {
    stripePublishableKey: "pk_live_51OtemiGcFbCW4R1GbI7RVyx9CsWKwRCqXpc6TpJN4PGphsYVW5rwLVskuHnIApoSznZFJTVRWtNSekAejih4gqL000b8MCFGFK",
    baseUrl: "http://localhost:3000",
    imageBaseUrl: "/images/",
};

